import { TaggedPitchTypeLabelMap } from "./FilterValueMap"
import { hit_set, k_set, nibb_set, non_ab_set, strk_set, swing_set } from "./PersonalDataProcess"
import { getDecimalData, getPercentageData } from "./utilFuncs"

export const resolvePlayerIDMap = (data) => {
  let output = { options: {}, map: {} }
  let teams = new Set()
  teams.add("隊伍")
  teams.add("中華職棒")
  for (const d of data) {
    // add new instance when team data is not yet set
    if (output.options[d.Team] === undefined) {
      output.options[d.Team] = { pitcher: [], batter: [] }
      output.map[d.Team] = { pitcher: {}, batter: {} }
      teams.add(d.Team)
    }
    // add player to team data according to position and id and update id map
    if (d.Pos === 'P') {
      output.options[d.Team].pitcher.push(d.ID)
      output.map[d.Team].pitcher[d.ID] = d.Name
    } else {
      output.options[d.Team].batter.push(d.ID)
      output.map[d.Team].batter[d.ID] = d.Name
    }
  }
  output.teams = Array.from(teams)
  return output
}

export const extractHeadToHeadData = (data) => {
  // zoneGraph Data Process
  let swing_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let whiff_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let h_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ab_dn = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let fb_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let nfb_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let avg = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let fb_count = 0, nfb_count = 0
  let stats = { single: 0, double: 0, triple: 0, hr: 0, ihr: 0, pa: 0, ab: 0, so: 0, bb: 0, hbp: 0, sf: 0, ibb: 0, inplay: 0 }, ptypestats = {}
  for (const p of data) {
    if (["", 'UN', '?', null].includes(p.TaggedPitchType)) continue
   
    let zoneIdx = parseInt(p.OZone) > 10? parseInt(p.OZone)-2:parseInt(p.OZone)-1
    // count fastball and nonfastball in each zone
    if (["FB", "FT"].includes(p.TaggedPitchType)) {
      fb_count++
      fb_n[zoneIdx]++
    } else {
      nfb_count++
      nfb_n[zoneIdx]++
    }
    // accumulate at bat data
    if (p.PA_Result !== undefined && p.PA_Result[0] !== undefined) {
      stats.pa++
      if (!non_ab_set.includes(p.PA_Result)) {
        ab_dn[zoneIdx]++
        stats.ab++
        if (p.PA_Result === '1B') {
          stats.single++
        } else if (p.PA_Result === '2B') {
          stats.double++
        } else if (p.PA_Result === '3B') {
          stats.triple++
        } else if (p.PA_Result === 'HR') {
          stats.hr++
        } else if (p.PA_Result === 'IHR') {
          stats.ihr++
        }
      }
      if (k_set.includes(p.PA_Result)) {
        stats.so++
      } else if (nibb_set.includes(p.PA_Result)) {
        stats.bb++
      } else if (p.PA_Result === 'HBP') {
        stats.hbp++
      } else if (p.PA_Result === 'SF') {
        stats.sf++
      } else if (p.PA_Result === 'IBB') {
        stats.ibb++
      }

      if (p.PitchCode === 'In-Play' || p.PitchCode === 'Inplay') {
        stats.inplay++
      }
    }

    if (swing_set.includes(p.PitchCode)) {
      swing_n[zoneIdx]++
      if (p.PitchCode === 'Strk-S') {
        whiff_n[zoneIdx]++
      }
    }
    if (hit_set.includes(p.PA_Result)) {
      h_n[zoneIdx]++
    }
  }

  // calculate stat table entries
  let stat = []
  stat.push(stats.pa)
  stat.push(stats.ab)
  stat.push(stats.single+stats.double+stats.triple+stats.hr+stats.ihr)
  stat.push(stats.double)
  stat.push(stats.triple)
  stat.push(stats.hr+stats.ihr)
  stat.push(stats.bb)
  stat.push(stats.ibb)
  stat.push(stats.so)
  stat.push(getDecimalData(stat[2]-stats.hr, stats.inplay-stats.hr, 3, '-'))
  stat.push(getDecimalData((stats.double+stats.triple*2+stats.hr*3+stats.ihr*3), stats.ab, 3, '-'))
  stat.push(getDecimalData(stat[2], stats.ab, 3, '-'))
  stat.push(getDecimalData(stat[2]+stat[6]+stat[7], stats.pa, 3, '-'))
  stat.push(getDecimalData((stats.single+stats.double*2+stats.triple*3+stats.hr*4+stats.ihr*4), stats.ab, 3, '-'))
  stat.push(getDecimalData(parseFloat(stat[11])+parseFloat(stat[12]), 1, 3, '-'))

  // calculate percentage in each zone area
  for (let i=0; i<13; i++) {
    whiff_n[i] = getPercentageData(whiff_n[i], swing_n[i], 0, 0)
    fb_n[i] = getPercentageData(fb_n[i], fb_count, 0, 0)
    nfb_n[i] = getPercentageData(nfb_n[i], nfb_count, 0, 0)
    avg[i] = getDecimalData(h_n[i], ab_dn[i], 3, '-')
  }

  const grepData = {
    discipline: {count: 0, strk: 0, zswing: 0, oswing: 0, zcount: 0, ocount: 0, contact: 0, zcontact: 0, ocontact: 0, miss: 0, whiff: 0, swing: 0, inplay: 0},
  }
  let groupByPitchType = { all: {...grepData} }
  groupByPitchType.all.gameSet = new Set()
  for (const d of data) {
    // console.log(d)
    // merge FT into FB
    let pitch_type_tag = d.TaggedPitchType === 'FT'? 'FB':d.TaggedPitchType
    //Discipline
    if (groupByPitchType[pitch_type_tag] === undefined) {
      groupByPitchType[pitch_type_tag] = {
        discipline: {count: 0, strk: 0, zswing: 0, oswing: 0, zcount: 0, ocount: 0, contact: 0, zcontact: 0, ocontact: 0, miss: 0, whiff: 0, swing: 0, inplay: 0},
        score: {pa: 0, ab: 0, h: 0, ab_r: 0, ab_l: 0, h_r: 0, h_l: 0, obp: 0, xbh: 0, sf: 0, k: 0, bb: 0, hr: 0, tb: 0, ihr: 0},
        hit: {gb: 0, ld: 0, fb: 0, ifb: 0, hard: 0, soft: 0, med: 0, oppo: 0, straight: 0, pull: 0},
      }
      groupByPitchType[pitch_type_tag].gameSet = new Set()
    }
    groupByPitchType[pitch_type_tag].discipline.count++
    groupByPitchType.all.discipline.count++
    if (d.PitchCode === 'In-Play') {
      groupByPitchType[pitch_type_tag].discipline.inplay++
      groupByPitchType.all.discipline.inplay++
    }
    if (strk_set.includes(d.PitchCode)) {
      groupByPitchType[pitch_type_tag].discipline.strk++
      groupByPitchType.all.discipline.strk++
      if (parseInt(d.Zone)) {
        if (d.PitchCode !== 'Strk-C') {
          groupByPitchType[pitch_type_tag].discipline.zswing++
          groupByPitchType.all.discipline.zswing++
          groupByPitchType[pitch_type_tag].discipline.swing++
          groupByPitchType.all.discipline.swing++
          if (d.PitchCode !== 'Strk-S') {
            groupByPitchType[pitch_type_tag].discipline.zcontact++
            groupByPitchType.all.discipline.zcontact++
            groupByPitchType[pitch_type_tag].discipline.contact++
            groupByPitchType.all.discipline.contact++
          } else {
            groupByPitchType[pitch_type_tag].discipline.whiff++
            groupByPitchType.all.discipline.whiff++
          }
        } else {
          groupByPitchType[pitch_type_tag].discipline.miss++
          groupByPitchType.all.discipline.miss++
        }
      } else {
        if (d.PitchCode !== 'Strk-C') {
          groupByPitchType[pitch_type_tag].discipline.oswing++
          groupByPitchType.all.discipline.oswing++
          groupByPitchType[pitch_type_tag].discipline.swing++
          groupByPitchType.all.discipline.swing++
          if (d.PitchCode !== 'Strk-S') {
            groupByPitchType[pitch_type_tag].discipline.ocontact++
            groupByPitchType.all.discipline.ocontact++
            groupByPitchType[pitch_type_tag].discipline.contact++
            groupByPitchType.all.discipline.contact++
          } else {
            groupByPitchType[pitch_type_tag].discipline.whiff++
            groupByPitchType.all.discipline.whiff++
          }
        } else {
          groupByPitchType[pitch_type_tag].discipline.miss++
          groupByPitchType.all.discipline.miss++
        }
      }
    }
    if (parseInt(d.Zone)) {
      groupByPitchType[pitch_type_tag].discipline.zcount++
      groupByPitchType.all.discipline.zcount++
    } else {
      groupByPitchType[pitch_type_tag].discipline.ocount++
      groupByPitchType.all.discipline.ocount++
    }
    
  }
  // console.log(groupByPitchType)
  // Calculate for Result
  let discipline = []
  for (let tag in groupByPitchType) {
    //discipline
    let dcp = []
    dcp.push(groupByPitchType[tag].discipline.count)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.count, groupByPitchType.all.discipline.count))
    dcp.push(groupByPitchType[tag].discipline.strk)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.strk, groupByPitchType[tag].discipline.count))
    dcp.push(groupByPitchType[tag].discipline.zcount)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zcount, groupByPitchType[tag].discipline.count))
    dcp.push(groupByPitchType[tag].discipline.swing)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.swing, groupByPitchType[tag].discipline.count))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.swing, groupByPitchType[tag].discipline.strk))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zswing, groupByPitchType[tag].discipline.zcount))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.oswing, groupByPitchType[tag].discipline.ocount))
    dcp.push(groupByPitchType[tag].discipline.contact)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.contact, groupByPitchType[tag].discipline.swing))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zcontact, groupByPitchType[tag].discipline.zswing))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.ocontact, groupByPitchType[tag].discipline.oswing))
    dcp.push(groupByPitchType[tag].discipline.whiff)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.swing))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.count))
    dcp.push(groupByPitchType[tag].discipline.inplay)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.inplay, groupByPitchType[tag].discipline.count))
    discipline.push({title: TaggedPitchTypeLabelMap[tag], data: dcp})
  }

  let hit = [], take = [], swing_m = [], inplay = [], xbh = [], fo = [], go = []

  // assign pitch data by pitch code
  for (const d of data) {
    if (d.PitchCode === 'In-Play' || d.PitchCode === 'Inplay') {
      inplay.push(d)
      if (hit_set.includes(d.PA_Result)) {
        hit.push(d)
        if (d.PA_Result !== "1B") {
          xbh.push(d)
        }
      }
      if (["F","IF","SF"].includes(d.PA_Result)) {
        fo.push(d)
      } else if (["G","G-","GT","SH","DP","TP"].includes(d.PA_Result)) {
        go.push(d)
      }
    } else if (d.PitchCode === "Strk-C") {
      take.push(d)
    } else if (d.PitchCode === "Strk-S") {
      swing_m.push(d)
    }
  }


  return {
    kzone: { fb: fb_n, nfb: nfb_n, avg, whiff: whiff_n },
    discipline,
    stat,
    location: { all: data, hit, take, swing_m, inplay, xbh, fo, go }
  }
}